import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const StovetopIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "StovetopIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M16.4652 16.157C16.977 16.157 17.3919 15.7422 17.3919 15.2304C17.3919 14.7186 16.977 14.3037 16.4652 14.3037C15.9535 14.3037 15.5386 14.7186 15.5386 15.2304C15.5386 15.7422 15.9535 16.157 16.4652 16.157Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.481 2.56541H4.41876C3.39695 2.56541 2.56543 3.39694 2.56543 4.41874V20.481C2.56543 21.5028 3.39696 22.3343 4.41876 22.3343H20.481C21.5028 22.3343 22.3343 21.5028 22.3343 20.481V4.41874C22.3343 3.39693 21.5028 2.56541 20.481 2.56541ZM21.0988 20.481C21.0988 20.8214 20.8214 21.0988 20.481 21.0988H4.41876C4.07836 21.0988 3.80098 20.8214 3.80098 20.481V4.41874C3.80098 4.07834 4.07836 3.80096 4.41876 3.80096H20.481C20.8214 3.80096 21.0988 4.07834 21.0988 4.41874L21.0988 20.481Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.12502 11.2149C9.82823 11.2149 11.2139 9.82919 11.2139 8.12598C11.2139 6.42277 9.82823 5.03709 8.12502 5.03709C6.42181 5.03709 5.03613 6.42277 5.03613 8.12598C5.03613 9.82919 6.42181 11.2149 8.12502 11.2149ZM8.12502 6.27264C9.14683 6.27264 9.97835 7.10417 9.97835 8.12597C9.97835 9.14777 9.14682 9.9793 8.12502 9.9793C7.10322 9.9793 6.27169 9.14777 6.27169 8.12597C6.27169 7.10417 7.10322 6.27264 8.12502 6.27264Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.4652 11.832C14.5914 11.832 13.0674 13.3561 13.0674 15.2298C13.0674 17.1035 14.5914 18.6276 16.4652 18.6276C18.3389 18.6276 19.8629 17.1035 19.8629 15.2298C19.8629 13.3561 18.3389 11.832 16.4652 11.832ZM16.4652 17.392C15.2729 17.392 14.3029 16.4221 14.3029 15.2298C14.3029 14.0375 15.2729 13.0676 16.4652 13.0676C17.6575 13.0676 18.6274 14.0375 18.6274 15.2298C18.6274 16.4221 17.6575 17.392 16.4652 17.392Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0832 5.03709C15.5505 5.03709 14.3032 6.28438 14.3032 7.81709C14.3032 9.3498 15.5505 10.5971 17.0832 10.5971C18.6159 10.5971 19.8632 9.3498 19.8632 7.81709C19.8632 6.28438 18.6159 5.03709 17.0832 5.03709ZM17.0832 9.36154C16.2319 9.36154 15.5388 8.66839 15.5388 7.81709C15.5388 6.96579 16.2319 6.27264 17.0832 6.27264C17.9345 6.27264 18.6277 6.96579 18.6277 7.81709C18.6277 8.66839 17.9345 9.36154 17.0832 9.36154Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.81613 12.4502C6.28342 12.4502 5.03613 13.6975 5.03613 15.2302C5.03613 16.7629 6.28342 18.0102 7.81613 18.0102C9.34884 18.0102 10.5961 16.7629 10.5961 15.2302C10.5961 13.6975 9.34884 12.4502 7.81613 12.4502ZM7.81613 16.7746C6.96483 16.7746 6.27168 16.0815 6.27168 15.2302C6.27168 14.3789 6.96483 13.6857 7.81613 13.6857C8.66743 13.6857 9.36058 14.3789 9.36058 15.2302C9.36058 16.0815 8.66743 16.7746 7.81613 16.7746Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.73526 19.2461H6.42637C6.08536 19.2461 5.80859 19.5228 5.80859 19.8639C5.80859 20.2049 6.08535 20.4816 6.42637 20.4816H6.73526C7.07627 20.4816 7.35304 20.2049 7.35304 19.8639C7.35304 19.5228 7.07628 19.2461 6.73526 19.2461Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.36075 19.2461H9.05186C8.71085 19.2461 8.43408 19.5228 8.43408 19.8639C8.43408 20.2049 8.71084 20.4816 9.05186 20.4816H9.36075C9.70176 20.4816 9.97853 20.2049 9.97853 19.8639C9.97853 19.5228 9.70177 19.2461 9.36075 19.2461Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.141 19.2461H11.8321C11.4911 19.2461 11.2144 19.5228 11.2144 19.8639C11.2144 20.2049 11.4911 20.4816 11.8321 20.4816H12.141C12.482 20.4816 12.7588 20.2049 12.7588 19.8639C12.7588 19.5228 12.482 19.2461 12.141 19.2461Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.9208 19.2461H14.6119C14.2709 19.2461 13.9941 19.5228 13.9941 19.8639C13.9941 20.2049 14.2709 20.4816 14.6119 20.4816H14.9208C15.2618 20.4816 15.5386 20.2049 15.5386 19.8639C15.5386 19.5228 15.2618 19.2461 14.9208 19.2461Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default StovetopIcon;
